import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";
const _NavIcon : SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 46 46"
        fill="none"
    >
        <path
            fill={props.fill}
            d="M28.657 17.343a2.666 2.666 0 0 0-1.876-.764l-8.099-.009a1.334 1.334 0 1 0 .01 2.668l6.194-.01-9.428 9.429a1.333 1.333 0 1 0 1.885 1.886l9.428-9.429v6.204a1.334 1.334 0 1 0 2.669.01l-.01-8.1a2.667 2.667 0 0 0-.773-1.885Z"
        />
    </svg>
)

const NavIcon = withColor(_NavIcon)
export default NavIcon
